import React from "react";
import ErrorPage from "../components/Error/Error";

const Error = () => <ErrorPage />;

export default Error;
